import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import address from './modules/Address'
import account from './modules/Account'
import preOrderSheets from './modules/PreOrderSheets'
import preOrders from './modules/PreOrders'
import products from './modules/Products'
import basket from './modules/Basket'
import notification from './modules/Notification'
import banner from './modules/Banner'
import branch from './modules/Branch'
import coupon from './modules/Coupon'
import downloads from './modules/Downloads'
import country from './modules/Country'
import sizeChart from './modules/SizeChart'
import currency from './modules/Currency'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    actions,
    getters,
    modules: {
        address,
        account,
        preOrderSheets,
        preOrders,
        products,
        notification,
        banner,
        basket,
        branch,
        coupon,
        downloads,
        country,
        sizeChart,
        currency
    },
    strict: false
})



// WEBPACK FOOTER //
// ./src/store/index.js